























import AbpBase from "../../../lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '../../../lib/util'
import {
    SaveLaboratoryCategories
} from "@/api/laboratoryCategories";
@Component({})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    form:any = {}
    created() {
        if(this.data.title=='编辑'){
            this.form = Object.assign({},this.data)
            console.log(this.form)
        }
    }
    rules = {}
    cancel(){
        (this.$refs.form as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    async save(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                let res = await SaveLaboratoryCategories(this.form)
                if(res.status==1){
                    this.$emit('input',false);
                    this.$emit('on-success')
                }
            }
        })
        
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/laboratoryCategories/saveLaboratoryCategories.vue